module.exports = __webpack_public_path__ + "img/contacts.f1a18fbd.png";